import BaseModel from "../core/BaseModel";
export default class ContractorUserViolationModel extends BaseModel {
  constructor() {
    super(
      {
        name: "contractor_user_violation",
        tableName: "sra_violation_history",
        label: "Vi Phạm An Toàn",
        display_key: 'sra_name',
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          class: "xs-col",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        sra_code: {
          name: "sra_code",
          label: "Mã gói công việc",
          type: "String",
          filter: { type: "input", match: "contains" },
        },
        sra_name: {
          name: "sra_name",
          label: "Tên gói công việc",
          type: "String",
          class: "large-col",
          filter: { type: "input", match: "contains" },
        },
        violation_date: {
          name: "violation_date",
          label: "Ngày vi phạm",
          type: "Date",
          filter: { type: 'DateRange', match: 'contains' },
        },
        violation_reason: {
          name: "violation_reason",
          label: "Lý do",
          type: "Text",
        },
      }
    );
  }
}
